import { takeLatest, put } from "redux-saga/effects";
import slice, {
  CREATE_STRIPE_SUBSCRIPTION_ITEM,
} from "store/stripe/subscriptionItems/slice";
import { createStripeSubscriptionItem } from "resources/services/stripeService";
import { FETCH_STRIPE_CUSTOMER } from "store/stripe/customer/slice";

function* create({ payload, meta }) {
  const { fetching, error, success } = slice.actions;

  yield put(fetching());
  try {
    const res = yield createStripeSubscriptionItem(payload);

    if (res.error) {
      throw new Error(res.error);
    }

    meta?.onSuccess && meta.onSuccess(res);

    yield put(FETCH_STRIPE_CUSTOMER());
    yield put(success());
  } catch (e) {
    const errorMsg = e.message ? e.message : e;
    meta?.onError && meta.onError(errorMsg);
    yield put(error(errorMsg));
  }
}

export default function* watchCreateSubscriptionItems() {
  yield takeLatest(CREATE_STRIPE_SUBSCRIPTION_ITEM.type, create);
}
